export default {"src":"/_next/static/media/ast.34ec285b.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};